import { Platform } from "react-native";

/**
 * Checks if the current web browser is running on a mobile or tablet device.
 * Returns false for native platforms (iOS/Android apps) and desktop browsers.
 */
const getIsMobileWeb = (): boolean => {
  if (Platform.OS !== "web" || typeof navigator === "undefined") {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(
      userAgent,
    );

  return isMobileDevice;
};

export const usePlatformOS = () => {
  const isWeb = Platform.OS === "web";
  const isMobileWeb = getIsMobileWeb();

  return {
    isWeb,
    isIOS: Platform.OS === "ios",
    isAndroid: Platform.OS === "android",
    isNative: ["ios", "android"].includes(Platform.OS),
    isMobileWeb,
    isDesktopWeb: isWeb && !isMobileWeb,
  };
};
